// https://www.npmjs.com/package/js-datepicker

/* eslint @typescript-eslint/no-var-requires: "off" */
import "js-datepicker/dist/datepicker.min.css"
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat'

dayjs.extend(customParseFormat)

const datepicker: any = require('js-datepicker')
const DATE_FORMAT = "DD/MM/YYYY";

function show(container: HTMLElement) {
    container.classList.remove("hide")
}

function hide(container: HTMLElement) {
    container.classList.add("hide")
}

function validate(container: HTMLElement, startElement: HTMLInputElement, endElement?: HTMLInputElement): Boolean {
    if (container.classList.contains("hide")) {
        return true
    }
    const startEmpty = startElement.value == "";
    manageValid(startElement, startEmpty);

    if (endElement) {
        const endEmpty = endElement.value == "";
        manageValid(endElement, endEmpty);
        return !(startEmpty || endEmpty);
    }
    return !startEmpty;
}

export function manageValid(element: HTMLElement, nonValid: Boolean) {
    const errorMessage = element
        .closest('.adform-input-wrapper')?.querySelector('.error-text') || null;

    element.classList.remove('invalid');
    errorMessage?.classList.remove('active');

    if (nonValid) {
        element.classList.add("invalid");
        errorMessage?.classList.add('active');
    }
}

export interface DatePickerInterface {
    show(): void
    hide(): void
    validate(): Boolean
    getValue(): RentDates
}

export class SingleDatepicker implements DatePickerInterface {
    private readonly container: HTMLElement
    private readonly dateElement: HTMLInputElement

    constructor(
        container: HTMLElement,
        dateElement: HTMLInputElement,
    ) {
        this.container = container;
        this.dateElement = dateElement;
    }

    public show() {
        show(this.container);
    }

    public hide() {
        hide(this.container);
    }

    public validate(): Boolean {
        return validate(this.container, this.dateElement);
    }

    public getValue(): RentDates {
        const start = dayjs(this.dateElement.value, DATE_FORMAT);
        return new RentDates(
            start.toDate(),
            undefined
        )
    }
}

function createDatePicker(dateElement: HTMLInputElement, datePickerId: string) {
    return datepicker("#" + dateElement.id, {
        id: datePickerId,
        formatter: (input: any, date: Date, instance: any) => {
            input.value = dayjs(date).format(DATE_FORMAT);
        },
        minDate: new Date(),
        onShow: (instance: any) => onDatepickerShow(instance)
    });
}

function onDatepickerShow(instance: any) {
    instance.calendarContainer.style.top = (instance.positionedEl.offsetHeight + 5) + 'px';
    instance.calendarContainer.style.left = '-1px';
    preventDoesntCompletelyVisible(instance);
}

function preventDoesntCompletelyVisible(instance: any) {
    let calendarContainer = instance.calendarContainer;
    if (calendarContainer.getBoundingClientRect().right > document.documentElement.clientWidth) {
        calendarContainer.style.right = getInitialX(instance);
        calendarContainer.style.left = '';
    } else {
        calendarContainer.style.left = getInitialX(instance)
        calendarContainer.style.right = '';
    }
    if (calendarContainer.getBoundingClientRect().bottom > document.documentElement.clientHeight) {
        calendarContainer.style.bottom = getInitialY(instance);
        calendarContainer.style.top = '';
    } else {
        calendarContainer.style.top = getInitialY(instance);
        calendarContainer.style.bottom = '';
    }
}

function getInitialY(instance: any) {
    let calendarContainer = instance.calendarContainer;
    if (calendarContainer.style.initialY == undefined) {
        calendarContainer.style.initialY = calendarContainer.style.top;
    }
    return calendarContainer.style.initialY;
}

function getInitialX(instance: any) {
    let calendarContainer = instance.calendarContainer;
    if (calendarContainer.style.initialX == undefined) {
        calendarContainer.style.initialX = calendarContainer.style.left;
    }
    return calendarContainer.style.initialX;
}


export class RentDatesDatepicker implements DatePickerInterface {
    private readonly container: HTMLElement
    private readonly startElement: HTMLInputElement
    private readonly endElement: HTMLInputElement

    static init(form: HTMLElement | null) {
        const container = form?.querySelector('.adform-rent-dates') as HTMLElement;
        const startElement = form?.querySelector('.js-date-start') as HTMLInputElement;
        const endElement = form?.querySelector('.js-date-end') as HTMLInputElement;

        if (container == null || startElement == null || endElement == null) {
            return null
        }
        return new RentDatesDatepicker(container, startElement, endElement)
    }

    static singleDateInit(form: HTMLElement | null, dateElement: HTMLInputElement | null) {
        const container = form?.querySelector('.adform-rent-dates') as HTMLElement;
        if (container == null || dateElement == null) {
            return null
        }
        createDatePicker(dateElement, dateElement.id);
        return new SingleDatepicker(container, dateElement)
    }

    private constructor(
        container: HTMLElement,
        startElement: HTMLInputElement,
        endElement: HTMLInputElement,
    ) {
        this.container = container;
        this.startElement = startElement;
        this.endElement = endElement;

        const datePickerId = startElement.id;
        createDatePicker(startElement, datePickerId);
        createDatePicker(endElement, datePickerId)
    }

    public show() {
        show(this.container);
    }

    public hide() {
        hide(this.container);
    }

    public validate(): Boolean {
        return validate(this.container, this.startElement, this.endElement);
    }

    public getValue(): RentDates {
        const start = dayjs(this.startElement.value, DATE_FORMAT);
        const end = dayjs(this.endElement.value, DATE_FORMAT);
        return new RentDates(
            start.toDate(),
            end.toDate()
        )
    }
}

export class RentDates {
    public start: Date;
    public end?: Date;

    constructor(start: Date, end?: Date) {
        this.start = start;
        this.end = end;
    }
}
